import { useSelector } from "react-redux"
import styled from "styled-components"
import backdrop from "../../images/img/backdrop.png"
import MessageInputTextArea from "../shared/input/special/MessageInputTextArea";
import { useEffect, useRef, useState } from "react";
import MessageCategories from "./MessageCategories";
import { useDispatch } from "react-redux";
import { closeSupportChat, closeSupportChatDemand, createChatMessage, getSupportCategory, sendChatMessage, setSelectedFile } from "../../features/messages/messageSlice";
import { FaRegUser } from "react-icons/fa";
import moment from "moment";
import { BsCheckAll, BsFillSendFill } from "react-icons/bs";
import { BsCheck } from "react-icons/bs";
import logo from "../../images/svg/colors/light/kamyoon-light.svg"
import darklogo from "../../images/svg/colors/dark/kamyoon-dark.svg"
import { FaRegFileImage } from "react-icons/fa";
import { FaRegFilePdf } from "react-icons/fa";
import { FaRegFileArchive } from "react-icons/fa";
import { FaRegFileExcel } from "react-icons/fa";
import { FaRegFileAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import MessageFileInput from "../shared/input/special/MessageFileInput";
import Btn from "../shared/button/Btn";
import { format } from 'date-fns';
import { SlEarphonesAlt } from "react-icons/sl";
import { getUserDocImage } from "../../features/user/userSlice";
import { showModal } from "../../features/modal/modalSlice";



const Container = styled.div`
    width: calc(100% - 290px);
    height: 70vh;
    border-radius: 10px;
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    background-image: url(${backdrop});
    background-size: contain;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .profile-container{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 70px;
        border-bottom: 1px solid;
        border-color:  ${({ theme }) => theme.mainBorderColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding-block: 10px;
        padding-inline: 25px;
        .profile{
            display: flex;
            align-items: center;
            gap: 10px;
            width: 75%;
            p{
                color:  ${({ theme }) => theme.mainTextColor};
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
            }
            .logo{
                max-width: 100px;
                max-height: 50px;
                width: 100%;
                height: 100%;
                border-radius: 50%;
                padding: 5px;
                background-color: ${({theme}) => theme.mainBgColor};
                display: flex;
                align-items: center;
                justify-content: center;
                svg{
                    width: 25px;
                    height: 25px;
                    color: ${({ theme }) => theme.contrastBorderColor};
                }
            }
            img{
                width: 100%;
                height: 100%;
                max-width: 100%;
                max-height: 50px;
            }
        }
        .close-chat{
            cursor: pointer;
            .support-phone{
                display: flex;
                flex-direction: column;
                align-items: center;
                p{
                    font-size: var(--font-size-xs) !important;
                }
            }
            p{
                display: flex;
                align-items: center;
                gap: 5px;
                color: var(--color-main);
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }
            svg{
                width: 20px;
                height: 20px;
            }
        }
    }
    .chat-container{
        height: calc(100% - 120px);
        width: 100%;
        max-height: 4000px !important;
        overflow: auto;
        padding: 25px;
        position: relative;
        .layout{
            position: absolute;
            width: calc(100% - 50px);
            height: calc(100% - 50px);
            background-color: rgba(0,0,0,0.8);
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;

            div{
                font-size: 2.5rem;
                font-weight: var(--font-weight-lg);
                color: #fff;
                text-align: center;
            }
        }
        
        .message{
            background-color: #EFEEEC;
            padding: 10px;
            border-radius: 10px;
            max-width: 70%;
            width: fit-content;
            text-align: left;
            margin-bottom: 5px;
            position: relative;
            color:  ${({ theme }) => theme.mainTextColor};

            p{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }
            span{
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                display: block;
                text-align: right;
                margin-top: 3px;
            }
            .file-message{
                background-color: #D2D1CE;
                border-radius: 10px;
                margin-bottom: 10px;
                width: 100px;
                .file-image{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    justify-content: center;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .file{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                    cursor: pointer;
                    padding-top: 10px;
                    p{
                        background-color: #C3C1BF;
                        padding: 10px;
                        border-bottom-left-radius: 10px;
                        border-bottom-right-radius: 10px;
                        width: 100%;
                        text-align: center;
                    }
                    span{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        svg{
                            text-align: center;
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
                
            }
        }
        .mine-message{
            background-color: #F19990;
            padding: 10px;
            border-radius: 10px;
            max-width: 70%;
            margin-left: auto;
            text-align: left;
            width: fit-content;
            margin-bottom: 5px;
            color: #fff;
            position: relative;
            p{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }
            .detail{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 3px;
                gap: 5px;
                span{
                    font-size: var(--font-size-xs);
                    font-weight: var(--font-weight-md);
                    display: block;
                }
                svg{
                    width: 20px;
                    height: 20px;
                }
            }
            .file-message{
                background-color: #ED776B;
                border-radius: 10px;
                margin-bottom: 10px;
                width: 100px;
                .file-image{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .file{
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                    padding-top: 10px;

                    p{
                        background-color: #EA6659;
                        padding: 10px;
                        border-bottom-left-radius: 10px;
                        border-bottom-right-radius: 10px;
                        width: 100%;
                        text-align: center;
                    }
                    span{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        svg{
                            text-align: center;
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
                
            }
        }
    }

    .category-container{
        width: 100%;
        padding: 20px;
        .category-list{
            display: flex;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap-reverse;
            .category-item{
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 10px;
                background-color: ${({theme}) => theme.mainBgColor};
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                padding: 10px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                cursor: pointer;
            }
        }
    }

    .demand-container{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        .demand-title{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
        }
        .demand-buttons{
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .textarea-container{
        width: 100%;
        height: auto;
        border-top: 1px solid ${({ theme }) => theme.mainBorderColor};
        padding: 15px;
        background-color: ${({theme}) => theme.secondaryBgColor};
        position: sticky;
        bottom: 0;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        position: relative;
        p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
        }
        .file-container{
            position: absolute;
            top: -55%;
            display: flex;
            align-items: center;
            gap: 10px;
            color:  ${({ theme }) => theme.mainTextColor};
            background-color: ${({theme}) => theme.secondaryBgColor};
            padding: 10px;
            height: 50px;
            svg{
                width: 25px;
                height: 25px;
            }
            .file-name{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }
            .file-close{
                cursor: pointer;
                svg{
                    width: 20px;
                    height: 20px;
                }
            }
        }
        .input-container{
            width: 100%;
            filter: none !important;
            background-color: ${({ theme }) => theme.mainBgColor};
            position: relative;
            border-radius: 10px;
            height: 100%;
            border: 1px solid ${({ theme }) => theme.mainBorderColor};
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            padding-right: 10px;

            .button-container{
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
            }
            .send {
                cursor: pointer;
                border-radius: 50%;
                padding: 10px;
                background-color: var(--color-main);
                display: flex;
                align-items: center;
                justify-content: center;

                &:disabled{
                    cursor: initial;
                    background-color: ${({theme}) => theme.secondaryBgColor};
                }

                svg {
                    width: 20px;
                    height: 20px;
                    color: #fff;
                }
            }
        }
    }

`

const ChatContainer = () => {
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const storageUserId = JSON.parse(storage.getItem("userId"))
    const rld = JSON.parse(storage.getItem("rld"))

    const {theme} = useSelector((state) => state.layout)
    const dispatch = useDispatch()
    const {selectedChat, selectedSubCategory, selectedCategory} = useSelector((state) => state.message)

    const [isDragging, setIsDragging] = useState(false)
    const [message, setMessage] = useState("")
    const [selectedFile, setSelectedFile] = useState(null)
    const lastMessageRef = useRef(null);
    const chatContainerRef = useRef(null);

    const isSupportAccount = "0e1bb90c-f5bb-4c65-b749-25e18d8dc9a0" === rld

    useEffect(() => {
        dispatch(getSupportCategory())
    }, [])

    const handleSubmit = () => {
        if(selectedChat){
            if(message){
                dispatch(sendChatMessage({message: message, supportChatId: selectedChat?.supportChatMessages[0]?.supportChatId, file: selectedFile}))
                setMessage("")
                setSelectedFile(null)
            }
        }else {
            if(message && (selectedSubCategory || selectedCategory)){
                dispatch(createChatMessage({title: message, supportCategoryId: selectedCategory?.id, description: message}))
                setMessage("")
                setSelectedFile(null)
            }
        }
    }

    const handleKeyDown = (e) => {
        if(message){
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSubmit();
            }
        }
    };

    useEffect(() => {
        if (lastMessageRef.current) {
            lastMessageRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [selectedChat?.supportChatMessages]);

    //! drag and drop
    const handleDrop = (e) => {
        e.preventDefault();
        setSelectedFile(e.dataTransfer.files[0])
        setIsDragging(false)
    }


    const handleDragOver = (e) => {
        e.preventDefault();

        setIsDragging(true)
        setSelectedFile(e.dataTransfer.files[0])
    }

    const handleDragLeave = (event) => {
        // Eğer fare div sınırları dışına çıkıyorsa isDragging'i false yap
        if (!chatContainerRef.current.contains(event.relatedTarget)) {
          setIsDragging(false);
        }
    };

    const handleUserDocImage = (image) => {
        if (image) {
          dispatch(getUserDocImage(`${process.env.REACT_APP_API_MESSAGES_FILE_URI}${image}`));
          dispatch(showModal("image"));
        }
    };

  return (

    <Container>
        <div className="profile-container">
            <div className="profile">
                <div className="logo">
                {isSupportAccount ?
                    selectedChat?.creatorUser?.profilePhoto ? 
                        <img src={process.env.REACT_APP_API_IMG_COMPANY_URI + `${selectedChat?.creatorUser?.profilePhoto}`} alt="profil" />
                        :
                        <FaRegUser />
                    :
                    <img src={theme === "dark" ? darklogo : logo} alt="" />
                }
                </div>
                {isSupportAccount && selectedChat?.creatorUser?.companyName && <p>{selectedChat?.creatorUser?.companyName}</p> }
                <p>{isSupportAccount ? selectedChat?.creatorUser?.adSoyadUnvan : "Kamyoon Destek"}</p>
            </div>
            <div className="close-chat">
                {(selectedChat && !selectedChat?.isClosed && isSupportAccount) ? 
                    <p onClick={() => dispatch(closeSupportChatDemand({id: selectedChat.id}))} >Konuşmayı Sonlandır</p> 
                    : 
                    <div className="support-phone">
                        <p>Acil Destek Hattı</p>
                        <p>+90 507 632 45 48 <SlEarphonesAlt /></p>
                    </div>
                }
            </div>
        </div>

        <div className="chat-container" ref={chatContainerRef} onDragLeave={handleDragLeave} isDragging={isDragging} onDrop={handleDrop} onDragOver={handleDragOver} onDragEnd={() => setIsDragging(false)} >
            {
                isDragging && 
                <div className="layout">
                    <div>Dosyayı Buraya Bırakabilirsin</div>
                </div>
            } 
            {selectedChat?.supportChatMessages?.map((item, index) => {
                return (
                    <div key={index} ref={index === selectedChat?.supportChatMessages?.length - 1 ? lastMessageRef : null} className={`${item.creatorUserId === storageUserId ? "mine-message" : "message"}`}>
                        {item.hasFile && 
                            <div className="file-message">
                                {item.fileUrl.endsWith(".pdf") && <div onClick={() => window.open(`${process.env.REACT_APP_API_MESSAGES_FILE_URI}${item.fileUrl}`, '_blank')} className="file"> <span><FaRegFilePdf /></span> <p>PDF</p></div> }
                                {item.fileUrl.endsWith(".doc") || item.fileUrl.endsWith(".docx") ? <div onClick={() => window.open(`${process.env.REACT_APP_API_MESSAGES_FILE_URI}${item.fileUrl}`, '_blank')} className="file"> <p><FaRegFileAlt /> Dosya</p> </div> : null}
                                {item.fileUrl.endsWith(".jpg") || item.fileUrl.endsWith(".jpeg") || item.fileUrl.endsWith(".png") || item.fileUrl.endsWith(".webp") || item.fileUrl.endsWith(".svg") ? <div className="file-image" onClick={() => handleUserDocImage(item.fileUrl)}> <img src={`${process.env.REACT_APP_API_MESSAGES_FILE_URI}${item.fileUrl}`} alt="" /></div> : null}
                                {item.fileUrl.endsWith(".zip") || item.fileUrl.endsWith(".rar") ? <div onClick={() => window.open(`${process.env.REACT_APP_API_MESSAGES_FILE_URI}${item.fileUrl}`, '_blank')} className="file"> <span><FaRegFileArchive /></span> <p>Sıkıştırılmış Dosya</p> </div> : null}
                                {item.fileUrl.endsWith(".xlsx") ? <div onClick={() => window.open(`${process.env.REACT_APP_API_MESSAGES_FILE_URI}${item.fileUrl}`, '_blank')} className="file"> <span><FaRegFileExcel /></span> <p>Excel</p> </div> : null}
                            </div>
                        }
                        <p>{item.message}</p>
                        <div className="detail">
                            <span>
                                {moment(item?.createdAt).isSame(new Date(), 'day') 
                                ? moment(item?.createdAt).format("HH:mm")
                                : moment(item?.createdAt).isSame(moment().subtract(1, 'day'), 'day')
                                ? `Dün ${moment(item?.createdAt).format("HH:mm")}`
                                : moment(item?.createdAt).format("DD.MM.YYYY HH:mm")
                                }
                                {/* {format(new Date(item?.createdAt), 'dd-MM-yyyy HH:mm')} */}
                            </span>
                            {item.creatorUserId === storageUserId && item.isRead && <BsCheckAll />}
                            {item.creatorUserId === storageUserId && !item.isRead && <BsCheck />}
                        </div>
                    </div>
                )
            })}
        </div>

        {!selectedChat && !isSupportAccount &&
            <MessageCategories />
        }

        
        
        <div className="textarea-container">
        {selectedChat && selectedChat?.isClosed &&
            <p>Bu mesajlaşma Kamyoon Destek tarafından sonlandırılmıştır.</p>
        }
        {
            !selectedChat?.isClosed && !selectedChat?.isClosedPending &&
            <>
                {selectedFile && 
                    <div className="file-container">
                        <div className="file-icon">
                            {selectedFile.name.endsWith(".pdf") && <FaRegFilePdf />}
                            {selectedFile.name.endsWith(".doc") || selectedFile.name.endsWith(".docx") ? <FaRegFileAlt /> : null}
                            {selectedFile.name.endsWith(".jpg") || selectedFile.name.endsWith(".png") || selectedFile.name.endsWith(".webp") || selectedFile.name.endsWith(".svg") ? <FaRegFileImage /> : null}
                            {selectedFile.name.endsWith(".zip") || selectedFile.name.endsWith(".rar") ? <FaRegFileArchive /> : null}
                            {selectedFile.name.endsWith(".xlsx") ? <FaRegFileExcel /> : null}
                        </div>
                        <div className="file-name">
                            {selectedFile.name} dosyası yüklendi.
                        </div>
                        <div onClick={() => setSelectedFile(null)} className="file-close">
                            <IoClose />
                        </div>
                    </div>
                }
                <div className="input-container">
                    <MessageInputTextArea placeholder={ !selectedChat && !isSupportAccount && ((selectedCategory?.name !== null && selectedCategory?.name === "Acil Destek Hattı" && "Lütfen aranmak istediğiniz telefon numarasını giriniz. (Örn: 05** *** ** **)") || (selectedCategory?.name !== "Acil Destek Hattı" && "Destek almak istediğiniz kategoriyi seçip açıklama yazınız.") )} onKeyDown={handleKeyDown} data={message} setData={(e) => setMessage(e.target.value)} name={"message"} labelText={""} inputWidth={"100%"} />
                    <div className="button-container">
                        <MessageFileInput setSelectedFile={setSelectedFile} />
                        <button className="send" onClick={handleSubmit}>
                            <BsFillSendFill />
                        </button>
                    </div>
                </div>
            </>
        }

        {selectedChat && !isSupportAccount && selectedChat?.isClosedPending &&
            <div className="demand-container">
                <div className="demand-title">Konuşma sonlandırılsın mı? Aldığınız cevaplar yeterli oldu mu?</div>
                <div className="demand-buttons">
                    <Btn bgColor="transparent" color="#E85446" padding="0 10px" handleClick={() => dispatch(closeSupportChat({id: selectedChat.id, response: true }))} >Sonlandır</Btn>
                    <Btn bgColor="transparent" color="#E85446" padding="0 10px" handleClick={() => dispatch(closeSupportChat({id: selectedChat.id, response: false }))} >Devam Et</Btn>
                </div>
            </div>
        }
        </div> 
    </Container>
  )
}

export default ChatContainer